module.exports = __webpack_public_path__ + "img/cocteleria_5_1.8b4f1cd9.png";